import client from './client';

export async function listLeads(params) {
  const { data } = await client.get('/leads', { params });
  return data.data; // Laravel paginator
}

export async function getLead(id) {
  const { data } = await client.get(`/leads/${id}`);
  return data.data;
}

export async function createLead(payload) {
  const { data } = await client.post('/leads', payload);
  return data.data;
}

export async function updateLead(id, payload) {
  const { data } = await client.put(`/leads/${id}`, payload);
  return data.data;
}

export async function deleteLead(id) {
  await client.delete(`/leads/${id}`);
}

export async function convertLead(id) {
  const { data } = await client.post(`/leads/${id}/convert`);
  return data.data;
}

export async function uploadLeadDocument(leadId, formData) {
  const { data } = await client.post(`/leads/${leadId}/documents`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data.data;
}

export async function downloadLeadDocument(id) {
  const response = await client.get(`/lead-documents/${id}/download`, { responseType: 'blob' });
  return response;
}

export async function deleteLeadDocument(id) {
  await client.delete(`/lead-documents/${id}`);
}
